import { get, post, put, remove } from "../../api_helper";
import * as url from "../../url_helper";

const baseURL = process.env.REACT_APP_API_DOTNET_URL;

export const createDOAHRJVInternalLog = (payload) => post(baseURL + url.DOA_HR_JV_INTERNAL_LOG, payload);
export const getDOAHRJVInternalLogDetails = (id) => get(`${baseURL + url.DOA_HR_JV_INTERNAL_LOG}/${id}`);
export const updateDOAHRJVInternalLog = (id, payload) => put(`${baseURL + url.DOA_HR_JV_INTERNAL_LOG}/${id}`, payload);
export const deleteDOAHRJVInternalLog = (id) => remove(`${baseURL + url.DOA_HR_JV_INTERNAL_LOG}/${id}`);
